<template>
  <div class="appVersion">
    <div class="inner" :class="needsUpdated ? 'needs_updated' : ''">
      <div class="col-sm-10 col-md-8 ml-auto mr-auto pt-4">
        <CCard>
          <CCardBody>
            <h5 style="width:100%;float:left;text-align:center;">Looks like there has been an update and you need to refresh your screen to get the updated version. If you are in the middle of an order, please close this popup and try and save for later. Otherwise, please click the refresh button to update your version.</h5>

            <div style="width:100%;float:left;text-align:center;margin-top:20px;">
              <CButton size="sm" color="info" @click="refresh()">Refresh <CIcon name="cil-reload" /></CButton>
              <CButton size="sm" class='ml-2' color="secondary" @click="needsUpdated = false">Close</CButton>
            </div>
          </CCardBody>
        </CCard>
      </div>
    </div>
    <div class="updatingApp" v-if="updatingApp">
      <div class="col-sm-10 col-md-8 ml-auto mr-auto pt-4">
        <CCard>
          <CCardBody class="text-center">
            <h5 style="width:100%;float:left;text-align:center;">There are currently updates happening to the site. You can stay on the current page and this message box will go away when the updates are complete. If the box has been up for a long time, you might try refreshing to see if it's complete. If this is urgent and you need to get into the site, please contact acehelpdesk@imperial1916.com. Thanks!</h5>

            <h5 style="width:100%;float:left;text-align:center;color:red;" v-if="updateMessage">{{updateMessage}}</h5>

            <CButton size="sm" color="info" @click="refresh()">Refresh</CButton>

          </CCardBody>
        </CCard>
      </div>
    </div>
    <div class="updatingApp" v-if="upcomingUpdate">
      <div class="col-sm-10 col-md-8 ml-auto mr-auto pt-4">
        <CCard>
          <CCardBody class="text-center">
            <h5 style="width:100%;float:left;text-align:center;">ATTENTION: There will be an update within the next 5-10 minutes. If you have any order that you're working on, please finish the order or save it for later. Thanks!</h5>

            <h5 style="width:100%;float:left;text-align:center;color:red;" v-if="updateMessage">{{updateMessage}}</h5>

            <CButton size="sm" color="info" @click="upcomingUpdate = false">I Understand, Close.</CButton>

          </CCardBody>
        </CCard>
      </div>
    </div>
  </div>
</template>
<script>
var methods = {}

methods.refresh = function () {
  // sessionStorage.clear()
  // localStorage.clear()
  localStorage.setItem('app_version', JSON.stringify(this.version))
  window.location.reload(true);
}

methods.getAppVersion = function () {
  axios.get(this.$apiAdress + '/api/app/getAppVersion?token=' + localStorage.getItem('api_token')).then(response => {
    var app
    console.log(response)
    // this.version = response.data
    this.checkVersion(response.data, 'function') 
  })
}

methods.checkVersion = function (version, type) {
  this.version = version
  var app
  // if (localStorage.getItem('app_version')) {
  //   app = JSON.parse(localStorage.getItem('app_version'))
  // } else {
  //   app = ''
  // }
  this.updatingApp = false
  this.needsUpdated = false
  this.upcomingUpdate = false
  console.log('version')
  console.log(version)
  if (parseInt(version.updating_app) === 1) {
      this.updatingApp = true
      if (version.update_message) {
        this.updateMessage = version.update_message
      }
  } else if (parseInt(version.upcoming_update) === 1) {
    console.log('in upcoming update')
    this.upcomingUpdate = true
    if (version.update_message) {
      this.updateMessage = version.update_message
    }
    // localStorage.setItem('app_version', JSON.stringify(version))
  } else {
    if (this.$store.state.version) {
      if (this.$store.state.version !== version.version) {
        if (type === 'function') {
          // this.refresh()
          this.needsUpdated = true
        } else {
          this.needsUpdated = true
        }
      }
    }
  }
}

export default {
  // ===Component name
  name: "AppVersion",
  // ===Props passed to component
  props: {},
  // ===Components used by this component
  components: {

  },
  // ====component Data properties
  data(){
      return{
        needsUpdated: false,
        version: null,
        updatingApp: false,
        upcomingUpdate: false,
        updateMessage: null
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getAppVersion()
    var that = this
    // setTimeout(function () {
      window.Echo.channel('app_version_update').listen('SendAppUpdate', (payload) => {
          console.log('CHANGEEEEE')
          console.log(payload);
          that.checkVersion(payload.app, 'not-function')

      });
    // },1000)
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .appVersion {
    // display: none;

    .inner {
      display: none;

      &.needs_updated {
        display: block !important;
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom: 0;
        width:100%;
        height:100%;
        z-index: 1050;
        background-color: rgba(0,0,0,.7);

      }
    }
    .updatingApp {
      display: block !important;
      position:fixed;
      top:0;
      left:0;
      right:0;
      bottom: 0;
      width:100%;
      height:100%;
      z-index: 1051;
      background-color: rgba(0,0,0,.7);
    }
  }
</style>
